import {
  Stack,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ClientAvatarImage from "assets/client-avatar.png";
import PasswordCheckList from "components/Feedback/PasswordCheckList/PasswordCheckList";
import Page from "components/Layout/Page/Page";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { maskPhoneNumber, sanitizeEmail } from "utils/Masks/Masks";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useConsigazApi } from "hooks/useConsigazApi";
import { useAuth } from "hooks/useAuth";
import ClienteService from "services/cliente";

export default function RegisterContaSim() {
  const [showPassword, setShowPassword] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const api = useConsigazApi();

  const { state } = useLocation();

  const handlePasswordFocus = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handlePasswordBlur = (e) => {
    formik.handleBlur(e);
    setAnchorEl(null);
  };

  const { login } = useAuth();

  const featureFlagNovaFormaAcessoContaSim = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_CONTASIM === "true";
  const featureFlagNovaFormaAcessoIndustrial = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_INDUSTRIAL === "true";
  const featureFlagNovaFormaAcesso = featureFlagNovaFormaAcessoContaSim || featureFlagNovaFormaAcessoIndustrial;
  const featureFlagOCREnabled = process.env.REACT_APP_OCR_ENABLED === "true";

  const registerUser = async () => {
    const password = formik.values.password;

    try {
      const response = await api.createUser({
        type: "CONTASIM",
        name: formik.values.name,
        phone: formik.values.phone,
        email: formik.values.email,
        password: password,
        cpf: state.cpfCnpj.replace(/\D/g, ""),
      });

      if (response.Erros && response.Erros.length) {
        return toast.error(response.Erros[0].Descricao);
      }

      if (state.existentClient) {
        return router.push("/login");
      }

      const success = await login({
        password,
        cpfCnpj: state.cpfCnpj.replace(/\D/g, ""),
        type: "CONTASIM",
      });

      if (success) {
        ClienteService.newClienteData = {
          cpfcnpj: state.cpfCnpj.replace(/\D/g, ""),
          name: formik.values.name,
          phoneNumber: formik.values.phone,
          emailAddress: formik.values.email,
        };
        return router.push({
          pathname: featureFlagNovaFormaAcesso && featureFlagOCREnabled ? "/validate-documents" : "/address-search",
        });
      }
    } catch (error) {
      console.error("Erro ao criar usuário:", error);
      return toast.error(error);
    }
  };

  const editUser = async () => {
    const password = formik.values.password;

    try {
      const response = await api.editUser({
        type: "CONTASIM",
        name: formik.values.name,
        phone: formik.values.phone,
        email: formik.values.email,
        password: password,
        cpf: state.cpfCnpj.replace(/\D/g, ""),
      });

      if (response.Erros && response.Erros.length) {
        return toast.error(response.Erros[0].Descricao);
      }

      const success = await login({
        password,
        cpfCnpj: state.cpfCnpj.replace(/\D/g, ""),
        type: "CONTASIM",
      });

      if (success) {
        ClienteService.newClienteData = {
          cpfcnpj: state.cpfCnpj.replace(/\D/g, ""),
          name: formik.values.name,
          phoneNumber: formik.values.phone,
          emailAddress: formik.values.email,
        };
        return router.push({
          pathname: "/address-search",
        });
      }
    } catch (error) {
      console.error("Erro ao criar usuário:", error);
      return toast.error(error);
    }
  };

  const router = useHistory();

  const validationRegisterContaSimSchema = Yup.object({
    name: Yup.string().required("Nome é obrigatório"),
    phone: Yup.string().required("Telefone é obrigatório"),
    email: Yup.string().email("Email inválido").required("Email é obrigatório"),
    confirmEmail: Yup.string()
      .required("Confirmação de email é obrigatória")
      .oneOf([Yup.ref("email")], "Os emails não coincidem"),
    password: Yup.string()
      .required("Senha obrigatória")
      .min(8, "A senha deve ter pelo menos 8 caracteres")
      .matches(/[A-Z]/, "Deve conter ao menos uma letra maiúscula")
      .matches(/\d/, "Deve conter ao menos um número")
      .matches(/[!@#$%^&*]/, "Deve conter ao menos um caractere especial"),
    confirmPassword: Yup.string()
      .required("Confirmação de senha é obrigatória")
      .oneOf([Yup.ref("password")], "As senhas não coincidem"),
  });

  const formik = useFormik({
    initialValues: {
      name: state?.nome || "",
      phone: "",
      email: "",
      confirmEmail: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationRegisterContaSimSchema,
    onSubmit: () => {
      if (state.accountHasPassword) {
        return editUser();
      }
      registerUser();
    },
  });

  const handleEmailChange = (field) => (e) => {
    formik.setFieldValue(field, sanitizeEmail(e.target.value));
  };

  return (
    <Page>
      <Stack
        justifyContent={"center"}
        alignItems="center"
        height="100vh"
        direction={"row"}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: 50,
            left: 70,
          }}
          onClick={() => router.push("/login")}
        >
          <ArrowBackIcon
            sx={{
              color: "#fff",
              fontSize: "31px",
            }}
          />
        </IconButton>
        <Stack
          border={"1px solid #fff"}
          padding={"32px 24px"}
          borderRadius={"8px"}
          direction={"row"}
          minHeight={"455px"}
          width={"930px"}
          gap={"40px"}
          mb={12}
        >
          <Stack width={"80%"} mt={"20px"}>
            <TextField
              variant="standard"
              placeholder="Nome"
              color="secondary"
              fullWidth
              sx={{
                "& .MuiInputBase-input": {
                  color: "#2CABF9",
                },
                "& input::placeholder": {
                  color: "gray",
                },
              }}
              {...formik.getFieldProps("name")}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
            <TextField
              variant="standard"
              placeholder="Telefone"
              color="secondary"
              sx={{
                mt: "60px",
                "& .MuiInputBase-input": {
                  color: "#2CABF9",
                },
                "& input::placeholder": {
                  color: "gray",
                },
              }}
              {...formik.getFieldProps("phone")}
              onChange={(e) => {
                const masked = maskPhoneNumber(e.target.value);
                formik.setFieldValue("phone", masked);
              }}
              error={formik.touched.phone && Boolean(formik.errors.phone)}
              helperText={formik.touched.phone && formik.errors.phone}
              fullWidth
            />
            <Stack direction={"row"} gap={"24px"} mt={"70px"}>
              <TextField
                variant="standard"
                placeholder="Email"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                {...formik.getFieldProps("email")}
                onChange={handleEmailChange("email")}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                fullWidth
              />
              <TextField
                variant="standard"
                placeholder="Confirmar email"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                {...formik.getFieldProps("confirmEmail")}
                onChange={handleEmailChange("confirmEmail")}
                error={
                  formik.touched.confirmEmail &&
                  Boolean(formik.errors.confirmEmail)
                }
                helperText={
                  formik.touched.confirmEmail && formik.errors.confirmEmail
                }
                fullWidth
              />
            </Stack>
            <Stack direction={"row"} gap={"24px"} mt={"69px"}>
              <TextField
                variant="standard"
                placeholder="Senha"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                type={showPassword ? "text" : "password"}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
                {...formik.getFieldProps("password")}
                onFocus={handlePasswordFocus}
                onBlur={handlePasswordBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                fullWidth
              />
              <TextField
                variant="standard"
                placeholder="Confirmar senha"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                type={showPassword ? "text" : "password"}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
                {...formik.getFieldProps("confirmPassword")}
                error={
                  formik.touched.confirmPassword &&
                  Boolean(formik.errors.confirmPassword)
                }
                helperText={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                }
                fullWidth
              />
            </Stack>
            <Button
              variant="contained"
              color="secondary"
              sx={{
                color: "#fff",
                height: "45px",
                borderRadius: "36px",
                marginTop: "55px",
                p: "10px",
              }}
              fullWidth
              onClick={formik.handleSubmit}
            >
              Avançar
            </Button>
          </Stack>
          <Stack justifyContent={"center"} alignItems={"center"} width={"30%"}>
            <Typography fontSize={"24px"} fontWeight={700} color="#fff">
              {state.existentClient
                ? "Informe seus dados"
                : "Ainda não é cliente?"}
            </Typography>
            <Typography
              fontSize={"12px"}
              fontWeight={400}
              color="#fff"
              mb={"24px"}
            >
              {state.existentClient
                ? "Forneça seus dados pessoais e cadastre sua senha, para acessar o portal Consigaz."
                : "Informe, ao lado, seus dados pessoais para acessar o portal Consigaz."}
            </Typography>
            <img
              src={ClientAvatarImage}
              style={{
                height: "206px",
                width: "154px",
              }}
            />
          </Stack>
        </Stack>
      </Stack>
      <PasswordCheckList
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        value={formik.values.password}
      />
    </Page>
  );
}
